const { PUBLIC_URL: publicUrl } = process.env;

export const getPublicPath = (filePath = null) =>
  filePath ? `${publicUrl}/${filePath}` : null;
